'use strict';

(() => {
  const templateSingleBox = document.createElement('template');

  templateSingleBox.innerHTML = /* html */ `
      <style>
        .container-info-box { max-width: 300px; margin: 8px 0; display: flex; background-color: #cfe2ff; border: 1px solid #d1d1d1; border-radius: 4px; padding: 20px 16px 16px;  font-size: 1rem; color: #212529; font-weight: 400; line-height: 1.5; }
        .font-family-default { font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; }
        .container-close { display: flex; justify-content: end; }
        .btn-close-svg { fill: #515151; height: 1.6rem; width: 1.6rem; border-radius: .4rem; background: transparent; cursor: pointer; margin-top: -20px; margin-right: -16px; }
        .shadow { box-shadow: 0 .5rem .5rem rgba(0,0,0,.40); }
        .container-content { width: 100%; }
        .wrapper-btn-ok { padding: 1rem 0 0 0; display: flex; justify-content: center; }
        .btn { cursor: pointer; text-align: center; text-decoration: none; user-select: none; border-radius: 0.375rem; border: 1px solid #8d8d8dff; background-color: #e2e2e2ff; color: #1b1b1bff; vertical-align: middle; font-size: 1rem; padding: 0.25rem 0.75rem; display: inline-block; }
      </style>
      <div class="container-info-box font-family-default" style="" part="style-content">
        <div>
          <div class="container-content" style="" part="container-content"></div>
          <div class="container-btn-ok"></div>
        </div>
        <div class="container-close" style="" part="container-close">
            <svg xmlns="http://www.w3.org/2000/svg" class="btn-close-svg"  style="" part="style-icon" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
        </div>
      </div>
    `;

  const btnOk = /* html */ `<div class="wrapper-btn-ok"><button class="btn font-family-default btn-ok" part="btn-ok">OK</button></div>`;

  class SingleBox extends HTMLElement {
    #root = null;
    #containerInfoBox = null;
    #timeOutID = null;
    #timeOut = 3000;
    #containerContent = null;
    #btnCloseSvg = null;
    #containerBtnOk = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'closed' });
      this.#root.appendChild(templateSingleBox.content.cloneNode(true));
      this.#containerInfoBox = this.#root.querySelector('div.container-info-box');
      this.#containerContent = this.#root.querySelector('div.container-content');
      this.#btnCloseSvg = this.#root.querySelector('svg.btn-close-svg');
      this.#containerBtnOk = this.#root.querySelector('.container-btn-ok');
      this.#btnCloseSvg.addEventListener('click', (e) => {
        this.#closeInfoBox();
      });
    }

    static get observedAttributes() {
      return ['text-content', 'style-content', 'time-out', 'icon-color', 'icon-bg', 'style-icon', 'top-space', 'has-shadow'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'text-content') {
        this.#containerContent.innerHTML = newValue;
      } else if (name === 'time-out') {
        this.#timeOut = Number(newValue);
        if (this.#timeOut === 0) {
          this.#containerBtnOk.innerHTML = btnOk;
          this.#containerBtnOk.querySelector('.btn-ok').addEventListener('click', (e) => {
            this.#closeInfoBox();
          });
        }
      } else if (name === 'style-content') {
        this.#containerInfoBox.style = newValue;
      } else if (name === 'icon-color') {
        this.#btnCloseSvg.style.fill = newValue;
      } else if (name === 'icon-bg') {
        this.#btnCloseSvg.style.background = newValue;
      } else if (name === 'style-icon') {
        this.#btnCloseSvg.style = newValue;
      } else if (name === 'has-shadow') {
        this.#containerInfoBox.classList.add('shadow');
      }
    }

    #closeInfoBox(e) {
      this.remove();
      clearTimeout(this.#timeOutID);
    }

    displayWithTimeOut() {
      if (this.#timeOut !== 0) {
        this.#timeOutID = setTimeout(() => {
          this.remove();
        }, this.#timeOut);
      }
    }
  }

  customElements.define('single-box', SingleBox);
  // ==========================================================
  // ==========================================================
  // ==========================================================
  const templateInfoBox = document.createElement('template');

  templateInfoBox.innerHTML = /* html */ `
      <style>
        .container{ display: flex; justify-content: center; position: relative; }
        .info-boxes { position: fixed; z-index: 99; top: auto; bottom: 10px; left: auto; right: 10px; transform: none; margin: unset; }
      </style>
      <section class="container" part="container">
        <div class="info-boxes" part="info-boxes">
        </div>
      </section>
    `;

  class InfoBox extends HTMLElement {
    #root = null;
    #infoBoxes = null;
    #isReverse = false;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'closed' });
      this.#root.appendChild(templateInfoBox.content.cloneNode(true));
      this.#infoBoxes = this.#root.querySelector('div.info-boxes');
    }

    static get observedAttributes() {
      return ['top-space', 'bottom-space', 'left-space', 'right-space', 'center-center', 'bottom-center', 'top-center', 'is-reverse'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'top-space') {
        this.#infoBoxes.style.top = newValue;
        this.#infoBoxes.style.bottom = 'unset';
        this.#infoBoxes.style.transform = 'none';
      } else if (name === 'bottom-space') {
        this.#infoBoxes.style.bottom = newValue;
        this.#infoBoxes.style.top = 'unset';
        this.#infoBoxes.style.transform = 'none';
      } else if (name === 'left-space') {
        this.#infoBoxes.style.left = newValue;
        this.#infoBoxes.style.right = 'unset';
        this.#infoBoxes.style.transform = 'none';
      } else if (name === 'right-space') {
        this.#infoBoxes.style.right = newValue;
        this.#infoBoxes.style.left = 'unset';
        this.#infoBoxes.style.transform = 'none';
      } else if (name === 'center-center') {
        this.#infoBoxes.style.bottom = 'unset';
        this.#infoBoxes.style.top = '50%';
        this.#infoBoxes.style.left = '50%';
        this.#infoBoxes.style.right = 'unset';
        this.#infoBoxes.style.transform = 'translate(-50%, -50%)';
      } else if (name === 'bottom-center') {
        this.#infoBoxes.style.bottom = newValue;
        this.#infoBoxes.style.left = 'unset';
        this.#infoBoxes.style.right = 'unset';
        this.#infoBoxes.style.margin = 'auto';
        this.#infoBoxes.style.transform = 'none';
      } else if (name === 'top-center') {
        this.#infoBoxes.style.top = newValue;
        this.#infoBoxes.style.left = 'unset';
        this.#infoBoxes.style.right = 'unset';
        this.#infoBoxes.style.margin = 'auto';
        this.#infoBoxes.style.transform = 'none';
      } else if (name === 'is-reverse') {
        this.#isReverse = true;
      }
    }

    #createInfoBox(textContent = '') {
      const singleBox = document.createElement('single-box');

      // "exportparts" ist dafür, dass die "part" von SingleBox auch außerhalb genutzt werden können.
      singleBox.setAttribute('exportparts', 'style-content, container-content, container-close, style-icon, btn-ok');
      singleBox.setAttribute('text-content', textContent);

      if (this.hasAttribute('time-out')) singleBox.setAttribute('time-out', this.getAttribute('time-out'));
      if (this.hasAttribute('style-content')) singleBox.setAttribute('style-content', this.getAttribute('style-content'));
      if (this.hasAttribute('icon-color')) singleBox.setAttribute('icon-color', this.getAttribute('icon-color'));
      if (this.hasAttribute('icon-bg')) singleBox.setAttribute('icon-bg', this.getAttribute('icon-bg'));
      if (this.hasAttribute('style-icon')) singleBox.setAttribute('style-icon', this.getAttribute('style-icon'));
      if (this.hasAttribute('has-shadow')) singleBox.setAttribute('has-shadow', this.getAttribute('has-shadow'));

      return singleBox;
    }

    #appendInfoBox(textContent) {
      const infoBox = this.#createInfoBox(textContent);
      this.#infoBoxes.append(infoBox);
      infoBox.displayWithTimeOut();
    }

    #appendInfoBoxReverse(textContent) {
      const infoBox = this.#createInfoBox(textContent);
      this.#infoBoxes.prepend(infoBox);
      infoBox.displayWithTimeOut();
    }

    // PUBLIC
    showInfoBox(textContent) {
      if (this.#isReverse === false) {
        this.#appendInfoBox(textContent);
      } else {
        this.#appendInfoBoxReverse(textContent);
      }
    }
  }

  customElements.define('info-box', InfoBox);
})();
